import type { HelpFile } from '../../types/help'
import { PageBackButtonTestIds } from '../../../testids/PageBackButtonTestIds'

export const pageBackButtonHelp: HelpFile = {
  texts: {
    [PageBackButtonTestIds.btnBack]: null,
  },
}
